@if (this.columns.length > 0) {
  <app-table
    [(selection)]="rowSelection"
    (focusDateChange)="focusDateChange()"
    [columns]="columns"
    [editable]="true"
    [firstColumnFrozen]="true"
    [focusDate]="focusDate"
    [focusDateClearable]="false"
    [hasFocusDate]="true"
    [headerGroups]="headerGroups"
    [selectable]="true"
    [showFrozenColumnSelection]="false">
    <ng-template
      (onClick)="addMissingOrganisations()"
      appToolbarButton
      icon="fal fa-plus"
      labelKey="ACTIONS.ADD_MISSING_ORGANISATIONS"></ng-template>
    <ng-template
      (onClick)="editRows()"
      [disabled]="rowSelection.length === 0"
      appToolbarButton
      icon="fal fa-pencil"
      labelKey="ACTIONS.EDIT"></ng-template>
  </app-table>
}
